
import { PreferenceSettings, ProfileWebchatSettings, WebchatSettings } from '@/libs/WebchatSettings';
import Vue from 'vue';

export interface SettingState {
    channelSettings: WebchatSettings;
    preferenceSettings: PreferenceSettings | {};
    profileSettings: ProfileWebchatSettings;
}

export const settings = {
    state: Vue.observable<SettingState>({
        channelSettings: {},
        preferenceSettings: {},
        profileSettings: {}
    }),
    setWebchatSettings(newSettings: WebchatSettings) {
        this.state.channelSettings = newSettings;
    },
    setPreferenceSettings(newSettings: PreferenceSettings) {
        this.state.preferenceSettings = newSettings;
    },
    setProfileSettings(newSettings: ProfileWebchatSettings) {
        this.state.profileSettings = newSettings;
    }
};

